document.addEventListener("DOMContentLoaded", function () {
    const navLinks = document.querySelectorAll('.nav-link.mobile-tab');

    navLinks.forEach(function (link) {
        link.addEventListener('click', function (event) {
            event.preventDefault();
            const newText = this.getAttribute('data-text');
            document.querySelector('#headingOne button').innerText = newText;
        });
    });
});
